import React, { useContext } from "react";
import { IntlContext } from "context";
import { SubCategory } from "types/subCategory";
import { useReferences } from "hooks/reference";
import { getListingDetailLabelKeys, type ListingCategoryDetail, type ListingDetailKind } from "./types";

interface Props {
    detail: ListingCategoryDetail;
    kind: ListingDetailKind;
}

const Assistance: React.FC<Props> = ({ detail, kind }) => {
    const intl = useContext(IntlContext);
    const reference = useReferences();
    const { subcategory, data } = detail;
    const labels = getListingDetailLabelKeys(kind);

    if (![SubCategory.TROUBLESHOOTING].includes(subcategory)) {
        return null;
    }

    return (
        <>
            <label>{intl.formatMessage(labels.deviceType)}</label>
            {data.device_type?.map((deviceType, key) => {
                const deviceTypeLength = data.device_type?.length ?? 0;
                const translatedDevice = reference.get("device", deviceType)?.value;

                if (key + 1 < deviceTypeLength) {
                    return `${translatedDevice}, `;
                }

                return `${translatedDevice}`;
            })}
        </>
    );
};

export default Assistance;
